import { AxiosResponse } from 'axios';

import axiosInstance from 'api/base';
import { normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { IAllPageFilters, IPageType, TObject } from 'utils/types';

import {
  normalizeMerchantGroup,
  normalizeMerchantGroupWithTerminals,
} from './normalizers';
import {
  IMerchantGroup,
  IMerchantGroupData,
  IMerchantGroupForm,
  IMerchantGroupFormEdit,
  IMerchantGroupWithTerminals,
} from './types';

const merchantGroupsApi = {
  async getAllMerchantGroups(
    filters: IAllPageFilters,
  ): Promise<IPageType<IMerchantGroup>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.get('merchant-terminal-groups', {
      params: normalizedFilter,
    });

    return normalizePageData<IMerchantGroupData, IMerchantGroup>(
      response.data,
      normalizeMerchantGroup,
      JSON.stringify(filters.search),
    );
  },

  async getMerchantGroup(id: string): Promise<IMerchantGroup> {
    const response = await axiosInstance.get(`merchant-terminal-groups/${id}`);
    return normalizeMerchantGroup(response.data);
  },

  async getMerchantGroupsList(
    merchantId: number,
  ): Promise<IMerchantGroupWithTerminals[]> {
    const response = await axiosInstance.get('merchant-terminal-groups/list', {
      params: { merchantId },
    });

    return ((response.data?.merchantGroups as TObject[]) || []).map(
      normalizeMerchantGroupWithTerminals,
    );
  },

  async deleteMerchantGroup(id: number): Promise<AxiosResponse> {
    const response = await axiosInstance.delete(`merchant-terminal-groups/${id}`);
    return response.data;
  },

  async createMerchantGroup(payload: IMerchantGroupForm): Promise<AxiosResponse> {
    const result = await axiosInstance.post(`merchant-terminal-groups`, payload);
    return result;
  },

  async updateMerchantGroup({
    data,
    id,
  }: IMerchantGroupFormEdit): Promise<AxiosResponse> {
    const result = await axiosInstance.put(`merchant-terminal-groups/${id}`, data);
    return result;
  },
};

export default merchantGroupsApi;
